import React, { Component } from "react";
import Snackbar from "material-ui-next/Snackbar";
import Dialog, {
  DialogTitle,
  DialogActions,
  DialogContent
} from "material-ui-next/Dialog";
import Button from "material-ui-next/Button";
import { colors } from "assets";

class Notifications extends Component {
  static dialogTypes = ["error", "confirmation"];
  static snackbarTypes = ["success", "warning"];

  snackbarAction = () => (
    <Button style={buttonStyle} onClick={() => this.hideNotification()} dense>
      Ok, Entendi
    </Button>
  );

  hideNotification = () => {
    this.props.presenter.onHideRequest();
  };

  onClickActionButton = callback => () => {
    callback();
    this.hideNotification();
  };

  buttonType = type => {
    switch (type) {
      case "primary":
        return { color: colors.primary.normal };
      case "accent":
        return { color: colors.accent.normal };
      default:
        return {};
    }
  };

  actionButton = ({ label, type, callback }) => (
    <Button
      key={label}
      onClick={this.onClickActionButton(callback)}
      style={{ ...this.buttonType(type) }}
      dense
    >
      {label}
    </Button>
  );

  actionButtons = () => (
    <DialogActions>
      {this.props.viewModel.actions.map(this.actionButton)}
    </DialogActions>
  );

  dialogContent = () => {
    const { content } = this.props.viewModel;

    const contentTags = (content.toString() || "")
      .split("\n")
      .map((part, idx) => (
        <div key={idx}>
          {part}
          <br />
        </div>
      ));

    if (content !== "") {
      return <DialogContent>{contentTags}</DialogContent>;
    }
  };

  dialogTitle = () => {
    const { title } = this.props.viewModel;

    if (title !== "") {
      return <DialogTitle>{title}</DialogTitle>;
    }
  };

  dialog = () => {
    const { visible, type } = this.props.viewModel;

    return (
      <Dialog
        open={visible && Notifications.dialogTypes.includes(type)}
        onClose={() => this.hideNotification()}
      >
        {this.dialogTitle()}
        {this.dialogContent()}
        {this.actionButtons()}
      </Dialog>
    );
  };

  snackbar = () => {
    const { visible, type, content } = this.props.viewModel;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        open={visible && Notifications.snackbarTypes.includes(type)}
        autoHideDuration={7000}
        message={content}
        action={this.snackbarAction()}
        onClose={() => this.hideNotification()}
      />
    );
  };

  render() {
    return (
      <div className="notifications">
        {this.snackbar()}
        {this.dialog()}
      </div>
    );
  }
}

const buttonStyle = {
  color: "white",
  backgroundColor: colors.accent.normal,
  fontWeight: "bold"
};

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/support/notifications/notifications.view.jsx